import { useQuery } from '@tanstack/react-query';
import { fetchAgreementSummariesByIds } from '../services/agreementSummaries';
import type { AgreementSummary } from '../types/fundAccountPostings.types';
import { dealerKeys } from './useDealersQuery';

export const useAgreementSummariesByIds = (ids: string[], enabled = true) => {
    const cleaned = Array.from(new Set(ids.filter(Boolean))).sort();
    return useQuery<AgreementSummary[]>({
        queryKey: dealerKeys.agreementSummaries(cleaned),
        queryFn: () => fetchAgreementSummariesByIds(cleaned),
        enabled: enabled && cleaned.length > 0,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};

export const buildAgreementRefMap = (summaries: AgreementSummary[] | undefined): Map<string, string> => {
    const map = new Map<string, string>();
    (summaries ?? []).forEach((summary) => map.set(summary.agreementId.toLowerCase(), summary.agreementRef));
    return map;
};

export const buildAgreementSummaryMap = (
    summaries: AgreementSummary[] | undefined,
): Map<string, AgreementSummary> => {
    const map = new Map<string, AgreementSummary>();
    (summaries ?? []).forEach((summary) => map.set(summary.agreementId.toLowerCase(), summary));
    return map;
};
